export default __webpack_public_path__ + "static/blob12-a36bed61d41b52c563472d599c2ed534.svg";